<div class="body">

    <object style="height: 100%; width: 100%; border: 0px;" [data]="safeUrl"></object>

</div>